import React from "react";
import styled from "@emotion/styled";


const Icon = styled.i`
  width:24px;
    height:24px;
    display: inline-block;
    margin-right: 10px;
    @media (min-width: 1140px) {
      margin-right: 15px;
    }
`;

export const WarningIcon = () => (
  <Icon>
    <svg xmlns="http://www.w3.org/2000/svg" className="width-full height-full" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0L24 0 24 24 0 24z" />
        <path
          fill="#DE3800"
          fillRule="nonzero"
          d="M21.595 11.025l-8.62-8.621c-.539-.539-1.412-.539-1.95 0l-8.621 8.62c-.539.539-.539 1.412 0 1.95l8.62 8.621c.539.539 1.412.539 1.95 0l8.621-8.62c.539-.539.539-1.411 0-1.95zm-8.687 5.52H11.09v-1.818h1.818v1.818zm0-3.636H11.09V7.455h1.818v5.454z"
        />
      </g>
    </svg>
  </Icon>
);

export const InfoIcon = () => (
  <Icon>
    <svg xmlns="http://www.w3.org/2000/svg"
      className="height-full width-full"
      width="16" height="16" viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0L16 0 16 16 0 16z" />
        <path
          fill="#006DFF"
          fillRule="nonzero"
          d="M8 1.333C4.318 1.333 1.333 4.318 1.333 8S4.318 14.667 8 14.667 14.667 11.682 14.667 8 11.682 1.333 8 1.333zm.667 10H7.333v-4h1.334v4zm0-5.333H7.333V4.667h1.334V6z"
        />
      </g>
    </svg>
  </Icon>

);


export const ErrorIcon = () => (
  <Icon>
    <svg xmlns="http://www.w3.org/2000/svg"
      className="height-full width-full"
      width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0L24 0 24 24 0 24z" />
        <path fill="#B60000" fillRule="nonzero"
          d="M22.718 17.451L13.92 2.816C13.614 2.305 13.075 2 12.479 2s-1.135.305-1.441.815L2.24 17.451c-.312.519-.32 1.168-.022 1.695.297.527.858.854 1.464.854h17.595c.605 0 1.167-.327 1.464-.854.298-.527.289-1.176-.023-1.695zM13.478 17h-2v-2h2v2zm0-4h-2V8h2v5z" />
      </g>
    </svg>
  </Icon>
);

export const SuccessIcon = () => (
  <Icon>
    <svg xmlns="http://www.w3.org/2000/svg"
      className="height-full width-full"
      width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0L24 0 24 24 0 24z" />
        <path fill="#008945" fillRule="nonzero"
          d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm4.666 5.5l-6.214 6.214-3.259-3.259L5.8 11.848l4.652 4.652 7.607-7.607L16.666 7.5z" />
      </g>
    </svg>
  </Icon>
);
